/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div v-if="logo === 'sada'" class="item-position bottom">Copyright © 北京萨达智能技术有限公司</div>
</template>

<script>

export default {
  name: 'Bottom',
  data () {
    return {}
  },
  props: {
    logo: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
  .bottom{
    bottom:0;
    left: 50%;
    transform: translateX(-50%);
    color:#5f7f9b;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Bottom.vue